/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftLevelUpInfoData model module.
 * @module model/NftLevelUpInfoData
 * @version 1.0
 */
class NftLevelUpInfoData {
    /**
     * Constructs a new <code>NftLevelUpInfoData</code>.
     * @alias module:model/NftLevelUpInfoData
     */
    constructor() { 
        
        NftLevelUpInfoData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftLevelUpInfoData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftLevelUpInfoData} obj Optional instance to populate.
     * @return {module:model/NftLevelUpInfoData} The populated <code>NftLevelUpInfoData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftLevelUpInfoData();

            if (data.hasOwnProperty('nftLevelingNo')) {
                obj['nftLevelingNo'] = ApiClient.convertToType(data['nftLevelingNo'], 'Number');
            }
            if (data.hasOwnProperty('timeToLevelup')) {
                obj['timeToLevelup'] = ApiClient.convertToType(data['timeToLevelup'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('nftDuration')) {
                obj['nftDuration'] = ApiClient.convertToType(data['nftDuration'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftLevelUpInfoData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftLevelUpInfoData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} nftLevelingNo
 */
NftLevelUpInfoData.prototype['nftLevelingNo'] = undefined;

/**
 * @member {Date} timeToLevelup
 */
NftLevelUpInfoData.prototype['timeToLevelup'] = undefined;

/**
 * @member {Date} createdAt
 */
NftLevelUpInfoData.prototype['createdAt'] = undefined;

/**
 * @member {Number} nftDuration
 */
NftLevelUpInfoData.prototype['nftDuration'] = undefined;






export default NftLevelUpInfoData;

